//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Privacy',
  data: function data() {
    return {
      pluginList: [{
        type: '基本功能',
        aim: '使用融云即时通讯组件SDK，为用户提供App内的即时通讯功能',
        name: '融云即时通讯组件',
        privarys: '设备信息',
        link: 'https://docs.rongcloud.cn/v4/5X/views/im/noui/intro/privacy.html'
      }, {
        type: '地图导航类',
        aim: '提供位置相关功能和服务',
        name: '高德地图 SDK',
        privarys: '设备信息，位置信息',
        link: 'https://lbs.amap.com/pages/privacy/'
      }, {
        type: '推送通知类',
        aim: '根据用户机型，为用户提供通知信息推送',
        name: '华为推送',
        privarys: '设备信息',
        link: 'https://developer.huawei.com/consumer/cn/devservice/term'
      }, {
        type: '推送通知类',
        aim: '根据用户机型，为用户提供通知信息推送',
        name: '小米推送',
        privarys: '设备信息',
        link: 'https://dev.mi.com/console/appservice/push.html'
      }, {
        type: '推送通知类',
        aim: '根据用户机型，为用户提供通知信息推送',
        name: 'VIVO推送',
        privarys: '设备信息',
        link: 'https://push.vivo.com.cn/'
      }, {
        type: '推送通知类',
        aim: '根据用户机型，为用户提供通知信息推送',
        name: 'OPPO推送',
        privarys: '设备信息',
        link: 'https://open.oppomobile.com/wiki/doc#id=10288'
      }, {
        type: '基本功能类',
        aim: '使用华为AppGallery Connect core SDK，为用户提供整合的华为内部各项优质服务',
        name: '华为服务SDK',
        privarys: '设备信息',
        link: 'https://developer.huawei.com/consumer/cn/doc/development/AppGallery-connect-Guides/agc-introduction'
      }, {
        type: '统计类',
        aim: '使用极光统计SDK了解用户的属性和使用情况，优化用户体验',
        name: '极光统计SDK',
        privarys: '设备信息',
        link: 'http://docs.jiguang.cn/janalytics/guideline/intro/'
      }, {
        type: '推送通知类',
        aim: '使用极光推送JPush SDK，可为用户提供终端消息推送服务',
        name: '极光SDK',
        privarys: '设备信息、网络信息、地理位置以及用户在使用开发者应用集成JPush SDK的功能时所产生的相关数据和信息',
        link: 'https://www.jiguang.cn/license/privacy'
      }, {
        type: '第三方支付类',
        aim: '使用支付宝支付SDK，为用户提供支付宝的支付功能',
        name: '支付宝',
        privarys: '设备信息',
        link: 'https://opendocs.alipay.com/open'
      }, {
        type: '基本功能类',
        aim: '使用听云SDK，可搜集用户端的崩溃和性能影响情况，以便优化用户体验',
        name: '听云',
        privarys: '设备信息',
        link: 'https://www.tingyun.com/legal_declaration.html'
      }, {
        type: '统计类',
        aim: '使用诸葛io SDK，提供用户端的用户行为分析，以便优化用户体验',
        name: '诸葛IO',
        privarys: '设备信息',
        link: 'https://docs.zhugeio.com/'
      }, {
        type: '地图导航类',
        aim: '提供位置相关功能和服务',
        name: '腾讯定位SDK',
        privarys: '设备信息，位置信息',
        link: 'https://privacy.qq.com/document/preview/dbd484ce652c486cb6d7e43ef12cefb0'
      }, {
        type: '地图导航类',
        aim: '提供位置相关功能和服务',
        name: '百度定位SDK',
        privarys: '设备信息，位置信息',
        link: 'https://lbs.baidu.com/index.php?title=openprivacy'
      }, {
        type: '第三方支付类',
        aim: '使用微信支付SDK，为用户提供微信支付功能',
        name: '微信Open SDK',
        privarys: '设备信息',
        link: 'https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/ONwPihxKd82RAkIJ'
      }, {
        type: '基本功能类',
        aim: '优化移动端浏览体验',
        name: 'TBS腾讯浏览服务SDK',
        privarys: '设备信息',
        link: 'https://x5.tencent.com/docs/privacy.html'
      }]
    };
  },
  computed: {
    privacyVisible: {
      get: function get() {
        return this.$store.state.login.privacyVisible;
      },
      set: function set(val) {
        return val;
      }
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('login/SET_PRIVACY', false);
    }
  }
};